import React from 'react';
import { Card } from 'reactstrap';

import IntlMessages from '../../../../../helpers/IntlMessages';
import { AreaChart } from '../charts';
import { ThemeColors } from '../../../../../helpers/ThemeColors';
const colors = ThemeColors();

const WebsiteVisitsChartCard = ({
  labels,
  visitorStatsData,
  isVoice = false,
}) => {
  const datasets = visitorStatsData.map((elem) => elem.count);
  const areaChartData = {
    labels,
    datasets: [
      {
        label: isVoice ? 'calls' : 'visitors',
        data: datasets,
        borderColor: colors.themeColor1,
        pointBackgroundColor: colors.foregroundColor,
        pointBorderColor: colors.themeColor1,
        pointHoverBackgroundColor: colors.themeColor1,
        pointHoverBorderColor: colors.foregroundColor,
        pointRadius: 4,
        pointBorderWidth: 2,
        pointHoverRadius: 5,
        fill: false,
        borderWidth: 2,
        backgroundColor: colors.themeColor1_10,
      },
    ],
  };
  return (
    <Card className={`dashboard-filled-line-chart`}>
      <div style={{ padding: '15px' }}>
        <div className="float-left float-none-xs">
          <div className="d-inline-block">
            <h5 className="d-inline">
              {isVoice ? (
                'Calls'
              ) : (
                <IntlMessages id="dashboards.website-visits" />
              )}
            </h5>
            <span className="text-muted text-small d-block">
              {isVoice ? (
                'Total round up calls'
              ) : (
                <IntlMessages id="dashboards.unique-visitors" />
              )}
            </span>
          </div>
        </div>
      </div>

      <div className="chart card-body pt-0">
        <AreaChart shadow data={areaChartData} />
      </div>
    </Card>
  );
};

export default WebsiteVisitsChartCard;
